import * as React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Macro } from "../../../../../../../../services/macros/types/macros";

interface MessageDialogProps {
  isOpen: boolean;
  title: string;
  default?: string;
  hideMessage?: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
  macros?: Macro[];
}

export const MessageDialog: React.FC<MessageDialogProps> = (props) => {
  const [message, setMessage] = React.useState(props.default || "");

  const [typing, setTyping] = React.useState(false);

  React.useEffect(() => {
    if (typing) {
      const timer = setTimeout(() => {
        setTyping(false);
      const macroMessage = props.macros?.find((m) => m.shortKey === message);
        if (macroMessage) {
          setMessage(macroMessage.message);
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [typing, message, props.macros]);

  const handleChange = (value: string) => {
    setMessage(value);
    setTyping(true);
  };

  return (
    <Dialog open={props.isOpen} onClose={props.onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
      {
      props.hideMessage ? null : (
        <DialogContent>
          <DialogContentText>
            Send a message to the Artist:
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Message"
            value={message}
            onChange={(ev) => handleChange(ev.target.value)}
            type="text"
            fullWidth
            multiline
            rows={8}
          />
        </DialogContent>
      )
      }
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => props.onSend(message)} color="default">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  )
}